import React from 'react';

/**
 * FeedTabs Component
 * 
 * Tabs: For You | Following | Explore | Community
 * Sticky on scroll, smooth transitions
 */

const FeedTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'for-you', label: 'For You', emoji: '✨' },
    { id: 'following', label: 'Following', emoji: '👥' },
    { id: 'explore', label: 'Explore', emoji: '🔍' },
    { id: 'community', label: 'Community', emoji: '🔥' }
  ];

  return (
    <div className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-4xl mx-auto">
        {/* Horizontal scrollable tabs - mobile first */}
        <div className="flex overflow-x-auto hide-scrollbar snap-x snap-mandatory">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex-shrink-0 snap-start py-3 px-6 text-sm font-medium transition-all duration-200 relative whitespace-nowrap ${
                activeTab === tab.id
                  ? 'text-purple-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                <span className="text-base">{tab.emoji}</span>
                <span>{tab.label}</span>
              </span>
              {/* Active indicator */}
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-purple-600 to-pink-500" />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeedTabs;
